var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-tabs',{staticClass:"border-card",attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"表格"}},[_c('Diagram')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"版本"}},[_c('Version')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fd31462","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/data/Data.vue
// module id = null
// module chunks = 